<template>
  <component :is="'style'">
    @keyframes rotate {
    100% {
    transform: rotate(360deg);
    }
    }
    dialog::backdrop {
    background: transparent;
    }
  </component>
  <dialog
    ref="dialog"
    :style="rootStyles"
    aria-label="Please wait"
    @keydown.esc.prevent
  >
    <div :style="innerStyles" />
  </dialog>
</template>

<script setup>
import { onMounted, ref } from 'vue';

const spinnerLoaderIcon = 'url("data:image/svg+xml,%3Csvg width=\'24\' height=\'24\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cpath d=\'M12 2c-.3 0-.6.1-.6.5v3.7c0 .4.3.6.6.6s.6-.2.6-.6V2.5c0-.4-.3-.6-.6-.6Zm0 15.2c-.3 0-.6.2-.6.6v3.7c0 .4.3.6.6.6s.6-.2.6-.6v-3.7c0-.4-.3-.6-.6-.6Zm9.5-5.8h-3.7c-.4 0-.6.3-.6.6s.2.6.6.6h3.7c.4 0 .6-.3.6-.6s-.2-.6-.6-.6Zm-15.3 0H2.5c-.4 0-.6.3-.6.6s.2.6.6.6h3.7c.4 0 .6-.3.6-.6s-.2-.6-.6-.6Zm10.3-3 2.6-2.7c.3-.2.2-.6 0-.8-.2-.2-.6-.3-.8 0l-2.6 2.6c-.3.3-.3.6 0 .8.2.3.5.3.8 0Zm0 7.3c-.3-.3-.6-.2-.8 0-.3.2-.3.5 0 .8l2.6 2.6c.2.3.6.2.8 0 .2-.2.3-.6 0-.8l-2.6-2.6ZM5.7 4.9c-.2-.3-.6-.2-.8 0-.2.2-.3.6 0 .8l2.6 2.6c.3.3.6.2.8 0 .3-.2.3-.5 0-.8L5.7 4.9Z\' fill=\'%23000\'/%3E%3C/svg%3E")';
const spinnerLoaderAnimation = 'rotate 800ms linear infinite';

const rootStyles = {
  position: 'fixed',
  zIndex: 3,
  top: '0',
  left: '0',
  width: '100vw',
  height: '100vh',
  margin: '0',
  padding: '0',
  border: '0',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'rgba(255,255,255,0.5)',
  maxWidth: '100vw',
  maxHeight: '100vh',
};

const innerStyles = {
  width: '24px',
  height: '24px',
  background: `${spinnerLoaderIcon} no-repeat center/24px`,
  animation: spinnerLoaderAnimation,
};

const dialog = ref(null);

onMounted(() => {
  dialog.value?.showModal?.();
});
</script>
